function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M63.67,23.06l-10.41-10.41c-1.56-1.57-3.69-2.44-5.9-2.44h-14.72c-2.21,0-4.34.88-5.9,2.44l-10.41,10.41c-1.56,1.57-2.44,3.69-2.44,5.9v14.72c0,2.21.88,4.34,2.44,5.9l9.06,9.06-4.71,8.15h-2.37c-.83,0-1.5.67-1.5,1.5s.67,1.5,1.5,1.5h43.39c.83,0,1.5-.67,1.5-1.5s-.67-1.5-1.5-1.5h-2.37l-4.71-8.16,9.06-9.06c1.56-1.57,2.44-3.69,2.44-5.9v-14.72c0-2.21-.88-4.34-2.44-5.9ZM55.86,66.8h-31.72l3.49-6.04c1.44,1.08,3.19,1.69,5.01,1.69h14.72c1.82,0,3.57-.6,5.01-1.69l3.49,6.04ZM37.6,36.32c0-1.33,1.08-2.4,2.4-2.4s2.4,1.08,2.4,2.4c0,.31-.06.6-.17.87-.35.9-1.22,1.53-2.23,1.53s-1.88-.64-2.23-1.53c-.11-.27-.17-.56-.17-.87ZM40,41.73c.45,0,.88-.06,1.29-.16l9.56,16.55c-.97.84-2.19,1.33-3.49,1.33h-14.72c-1.3,0-2.52-.48-3.49-1.33l9.56-16.55c.42.1.85.16,1.29.16ZM63.12,43.68c0,1.43-.56,2.77-1.57,3.78l-8.49,8.49-9.17-15.89c.93-.97,1.51-2.29,1.51-3.74,0-2.98-2.42-5.4-5.4-5.4s-5.4,2.42-5.4,5.4c0,1.45.58,2.77,1.51,3.74l-9.17,15.89-8.49-8.49c-1.01-1.01-1.57-2.35-1.57-3.78v-14.72c0-1.43.56-2.77,1.57-3.78l10.41-10.41c1.01-1.01,2.35-1.57,3.78-1.57h14.72c1.43,0,2.77.56,3.78,1.57l10.41,10.41c1.01,1.01,1.57,2.35,1.57,3.78v14.72Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M53.83,30.12c0-2.39-1.94-4.33-4.33-4.33s-4.33,1.94-4.33,4.33,1.94,4.33,4.33,4.33,4.33-1.94,4.33-4.33ZM49.5,32.45c-1.29,0-2.33-1.05-2.33-2.33s1.05-2.33,2.33-2.33,2.33,1.05,2.33,2.33-1.05,2.33-2.33,2.33Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M55.82,38.65c-2.39,0-4.33,1.94-4.33,4.33s1.94,4.33,4.33,4.33,4.33-1.94,4.33-4.33-1.94-4.33-4.33-4.33ZM55.82,45.32c-1.29,0-2.33-1.05-2.33-2.33s1.05-2.33,2.33-2.33,2.33,1.05,2.33,2.33-1.05,2.33-2.33,2.33Z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M49.27,20.59c0-2.39-1.94-4.33-4.33-4.33s-4.33,1.94-4.33,4.33,1.94,4.33,4.33,4.33,4.33-1.94,4.33-4.33ZM44.94,22.92c-1.29,0-2.33-1.05-2.33-2.33s1.05-2.33,2.33-2.33,2.33,1.05,2.33,2.33-1.05,2.33-2.33,2.33Z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M27.2,21.85c-2.39,0-4.33,1.94-4.33,4.33s1.94,4.33,4.33,4.33,4.33-1.94,4.33-4.33-1.94-4.33-4.33-4.33ZM27.2,28.51c-1.29,0-2.33-1.05-2.33-2.33s1.05-2.33,2.33-2.33,2.33,1.05,2.33,2.33-1.05,2.33-2.33,2.33Z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M28.39,40.13c.51-.71.82-1.58.82-2.52,0-2.39-1.94-4.33-4.33-4.33s-4.33,1.94-4.33,4.33c0,1.97,1.34,3.63,3.15,4.15-.51.71-.82,1.58-.82,2.52,0,2.39,1.94,4.33,4.33,4.33s4.33-1.94,4.33-4.33c0-1.97-1.34-3.63-3.15-4.15ZM27.2,46.6c-1.29,0-2.33-1.05-2.33-2.33s1.05-2.33,2.33-2.33,2.33,1.05,2.33,2.33-1.05,2.33-2.33,2.33ZM24.88,35.28c1.29,0,2.33,1.05,2.33,2.33s-1.05,2.33-2.33,2.33-2.33-1.05-2.33-2.33,1.05-2.33,2.33-2.33Z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M38.54,58.59c2.39,0,4.33-1.94,4.33-4.33s-1.94-4.33-4.33-4.33-4.33,1.94-4.33,4.33,1.94,4.33,4.33,4.33ZM38.54,51.93c1.29,0,2.33,1.05,2.33,2.33s-1.05,2.33-2.33,2.33-2.33-1.05-2.33-2.33,1.05-2.33,2.33-2.33Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 80 80"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

export default __webpack_public_path__ + "static/media/Lottery-inactive.6cc7f256.svg";
export { SvgComponent as ReactComponent };